import { render, staticRenderFns } from "./Form4.vue?vue&type=template&id=72a0d207&scoped=true"
import script from "./Form4.vue?vue&type=script&lang=js"
export * from "./Form4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0d207",
  null
  
)

export default component.exports